'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const IdeaRelatedItemViewTemplate = require('feedback/ui/template/idea/related-item.hbs');
const IdeaRelatedCollection = require('feedback/domain/collection/idea-related');
const Template = require('feedback/ui/template/idea/related-list.hbs');

const ItemSelectView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item idea-item',
    template: IdeaRelatedItemViewTemplate,
    templateContext: function() {
        return {
            url: `/feedback/ideas/${this.model.id}`,
            stateColor: this.model.getState().color,
            key: this.model.key,
        }
    },

    onAttach: function() {
        $.material.init();
    },
});

const IdeaListView = Mn.CollectionView.extend({
    className: 'list',
    childView: ItemSelectView,
});

const IdeaRelatedListView = Mn.View.extend({
    tagName: 'div',
    template: Template,
    regions: {
        ideaList: '.idea-list',
    },

    onRender: function () {
        const ideaKeys = this.getOption('ideaKeys');
        new IdeaRelatedCollection().fetchIdeasByIDs(
            _.map(ideaKeys, key => key.id)
        ).then( ideas => {
            this.showChildView('ideaList', new IdeaListView({
                collection: ideas
            }));
        });
    },
});

module.exports = IdeaRelatedListView;



// WEBPACK FOOTER //
// ./feedback/ui/view/idea/related-list.js